import { render, staticRenderFns } from "./DepartmentsList.vue?vue&type=template&id=68a93faf&scoped=true"
import script from "./DepartmentsList.vue?vue&type=script&lang=js"
export * from "./DepartmentsList.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsList.vue?vue&type=style&index=0&id=68a93faf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a93faf",
  null
  
)

export default component.exports